"use strict";

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var $doc = (0, _jquery2.default)(document);
var $win = (0, _jquery2.default)(window);

$doc.on("click", ".js-filtered-items a", function (e) {
  e.preventDefault();
  var $this = (0, _jquery2.default)(this);
  var href = $this.attr("href");

  var $anchorEl = (0, _jquery2.default)("#bc-sf-filter-tree").find(".bc-sf-filter-selection-wrapper").find("a[href=\"" + href + "\"]");
  $anchorEl.find(".bc-sf-filter-clear").trigger("click");
});

$doc.on("click", ".bc-sf-filter-block-title h3", function () {
  var $this = (0, _jquery2.default)(this);

  if ($win.width() < 768) {
    $this.parent().next(".bc-sf-filter-block-content").slideDown().closest(".bc-sf-filter-option-block").siblings().find(".bc-sf-filter-block-content").slideUp();
  }
});

$doc.on("click", ".product-view__filter-list__item", function () {
  console.log((0, _jquery2.default)(this).data("view"));
  if ((0, _jquery2.default)(this).data("view") === "list") {
    (0, _jquery2.default)(".product-listing").addClass("list");
    (0, _jquery2.default)(".list-view").addClass("selected");
    (0, _jquery2.default)(".grid-view").removeClass("selected");
  } else {
    (0, _jquery2.default)(".product-listing").removeClass("list");
    (0, _jquery2.default)(".list-view").removeClass("selected");
    (0, _jquery2.default)(".grid-view").addClass("selected");
  }
});